export const environment = {
  apiEndpoint: 'https://hmsapi.web2.anasource.com/api',
};
